import * as firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/functions';
import { LOGS, DETAILS } from 'utils/constants/collectionNames';
import { WORKOUT, TYPE, SUBTYPE } from 'utils/constants/logs';
import {
  GET_WORKOUT_LOGS_ERROR,
  GET_WORKOUT_LOGS_SUCCESS,
  LOADING_STATE
} from './Types';

export const getWorkoutLogs = clientId => async dispatch => {
  dispatch({ type: LOADING_STATE });
  const firestore = firebase.firestore();
  const queryRef = firestore
    .collection(LOGS)
    .doc(clientId)
    .collection(DETAILS)
    .where(TYPE, '==', WORKOUT)
    .where(SUBTYPE, '==', WORKOUT)

  queryRef
    .get()
    .then(snapshot => {
      if (snapshot.empty) {
        dispatch({
          type: GET_WORKOUT_LOGS_SUCCESS,
          payload: { workoutLogs: [] }
        });
        return;
      }
      let workoutLogs = [];
      snapshot.forEach(doc => {
        let workoutLog = { ...doc.data(), id: doc.id }
        workoutLogs.push(workoutLog);
      });

      dispatch({
        type: GET_WORKOUT_LOGS_SUCCESS,
        payload: { workoutLogs }
      });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: GET_WORKOUT_LOGS_ERROR,
        payload: `error: ${error}`
      });
    });
};
